import { PROYECT } from "services/api";
import { reportGasMovementsTypes } from "redux/reducers/Reports/reportGasMovements/types";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { saveAs } from 'file-saver';
import axios from "axios";
import { getErrorBlob } from "helpers/extractError";
const { SET_REPORT_GAS_MOVEMENTS_FILTERS } = reportGasMovementsTypes


export const getReportGasMovementsAction = ({ startDate, endDate, station, isPdf = true }) => {
  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user');
    const auth = { headers: { authorization: token } };
    const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/gas-movements/report/pdf?idStation=${station.id}&start=${startDate}&end=${endDate}&pdf=${isPdf}`;
    const fileName = `Reporte_Bonificaciones_gas_${station.name}_${startDate}_${endDate}.${isPdf ? 'pdf' : 'xlsx'}`;

    dispatch(startRequestComp('loadingReportGasMovements'))
    const access = {
      url: reportUrl,
      method: 'GET',
      responseType: 'blob',
      ...auth
    }
    try {
      const pdf = await axios(access)
      saveAs(pdf.data, fileName)
      dispatch(setSnackbar(`${isPdf ? 'PDF' : 'Excel'} Descargado con éxito`, "success"))
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)))
    } finally {
      dispatch(stopRequestComp('loadingReportGasMovements'))
    }
  }
}

export const setReportGasMovementsFilters = (key = "", value) => {
  return {
    type: SET_REPORT_GAS_MOVEMENTS_FILTERS,
    payload: { value, key }
  }
}
